import { cn } from "@client/utils/cn";

export default function Container({
  className,
  main,
  ...rest
}: React.HTMLAttributes<HTMLDivElement> & { main?: boolean }) {
  const Comp = main ? "main" : "div";

  return (
    <Comp
      className={cn(
        "mx-auto w-full sm:max-w-[640px] md:max-w-[768px] lg:max-w-[1024px] xl:max-w-[1364px] px-8 py-12 md:py-24",
        className,
      )}
      {...rest}
    />
  );
}
